import { HttpRequestPost } from './../../service/index';
import PushNotifications from "../symbols/createPushNotification";
import { getPushNotifications } from './pushNotifications';

export type CreatePushNotificationRequestModel = {
  Title: string;
  Body: string;
  Shops: string[];
  ScheduleDate?: string | null;
};
const createPushNotificationAction = () => ({
  type: PushNotifications.CREATE_PUSH_NOTIFICATION,
});
const createPushNotificationSuccessAction = (data: any) => ({
  type: PushNotifications.CREATE_PUSH_NOTIFICATION_SUCCESS,
  payload: data,
});
const createPushNotificationFailureAction = (data: any) => ({
  type: PushNotifications.CREATE_PUSH_NOTIFICATION_FAILURE,
  payload: data,
});
const clearPushNotificationsAction = () => ({
  type: PushNotifications.CLEAR_CREATE_PUSH_NOTIFICATION,
});

export function createPushNotification(data: CreatePushNotificationRequestModel, callback?: (resp?) => void) {
  let url = `/admin/create-push-notification`;
  return (dispatch: any) => {
    dispatch(createPushNotificationAction());
    HttpRequestPost(
      url,
      dispatch,
      createPushNotificationSuccessAction,
      createPushNotificationFailureAction,
      true,
      data,
      () => {
        if (callback) {
          callback();
        }
        dispatch(getPushNotifications({ Query: '' }));
      },
    );
  };
}

export function createCustomerPushNotification(data: FormData, callback?: (resp?) => void) {
  let url = `/admin/create-customer-push-notification`;
  return (dispatch: any) => {
    dispatch(createPushNotificationAction());
    HttpRequestPost(
      url,
      dispatch,
      createPushNotificationSuccessAction,
      createPushNotificationFailureAction,
      true,
      data,
      () => {
        if (callback) {
          callback();
        }
        dispatch(getPushNotifications({ Query: '' }));
      },
    );
  };
}


export function clearPushNotifications() {
  return (dispatch: any) => {
    dispatch(clearPushNotificationsAction());
  };
}
